import { toast } from "components/toastNotification";

const HierarchyGeneralInfo = ({
  data,
  onClickParentHierarchy,
  hierarchyData,
}) => {
  type DisplayRowProps = {
    label: string;
    value?: React.ReactNode;
  };

  const DisplayRow: React.FC<DisplayRowProps> = ({ label, value }) => (
    <div className="grid grid-cols-3 p-2">
      <label className="fontExpand expandedLabel mx-4">{label}</label>
      <div className="col-span-2 expandedData fontExpand">
        <label>{value}</label>
      </div>
    </div>
  );

  const fullTeamName = [
    data?.businessUnitHierarchyName,
    data?.marketHierarchyName,
    data?.stateHierarchyName,
    data?.districtHierarchyName,
    data?.teamHierarchyName,
  ]
    .filter(Boolean)
    .join("_");

  const display1stRow = [
    { label: "Hierarchy Name:", value: data?.hierarchyName },
    { label: "Hierarchy Type:", value: data?.hierarchyTypeName },
    data?.hierarchyTypeName === "Team"
      ? { label: "Team Name:", value: fullTeamName }
      : null,
    {
      label: "Hierarchy Id:",
      value: (
        <label className="px-2.5 py-0.5 rounded-md bg-purple-100 text-purple-800">
          {data?.hierarchyId}
        </label>
      ),
    },
    { label: "Description:", value: data?.description },
    { label: "Status:", value: data?.isActive ? "Active" : "Inactive" },
  ];

  const display2ndRow = [
    data?.hierarchyTypeName !== "Business Unit"
      ? {
          label: "Parent Hierarchy Id:",
          value: data?.parentHierarchyId,
        }
      : null,
    {
      label: "SPLC Hierarchy:",
      value: data?.isSplcHierarchy ? "Yes" : "No",
    },
    {
      label: "Is Franchise:",
      value: data?.isFranchise ? "Yes" : "No",
    },
  ].filter(Boolean);

  return (
    <>
      <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
        <div className="text-quinary font-bold font-sans py-2 px-6">
          SPLC Hierarchy Details
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
          <div className="p-2 divide-y">
            {display1stRow.map((item, i) =>
              item ? (
                <DisplayRow key={i} label={item.label} value={item.value} />
              ) : null
            )}
          </div>

          <div className="p-2 divide-y">
            {data?.hierarchyTypeName !== "Business Unit" && (
              <div className="grid grid-cols-3 p-2">
                <label className="fontExpand expandedLabel mx-4">
                  Parent Hierarchy:
                </label>
                <div className="col-span-2 expandedData fontExpand">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      const parentHierarchy = hierarchyData?.find(
                        (x) => x.hierarchyId === data?.parentHierarchyId
                      );
                      parentHierarchy
                        ? onClickParentHierarchy(parentHierarchy)
                        : toast.fire(
                            "Hierarchy",
                            "Parent hierarchy not found.",
                            "error"
                          );
                    }}
                  >
                    <span className="blueAndBold underline text-xs">
                      {data?.parentHierarchyName}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {display2ndRow.map((item, i) =>
              item ? (
                <DisplayRow key={i} label={item.label} value={item.value} />
              ) : null
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HierarchyGeneralInfo;
